/**
 * useAuth Hook
 * Custom hook to access authentication context
 * Separated from AuthContext to fix Fast Refresh compatibility
 */

import { useContext } from 'react';
import { AuthContext, AuthContextType } from '../AuthContext';

/**
 * Hook to access authentication context
 * @returns AuthContextType - Authentication state and methods
 * @throws Error if used outside AuthProvider
 */
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context as AuthContextType;
};
